import React from 'react';
import {
  MenuItem,
  Select,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import moment from 'moment';
import {
  CAL_REGISTER_FIELD_MONTHLY_DATEPICKER,
  CAL_REGISTER_FIELD_YEARLY_DATEPICKER,
  REPEAT_OPTION_MONTHLY,
  REPEAT_OPTION_WEEKLY,
  REPEAT_OPTION_YEARLY,
} from '../../common/consts';

const CalendarRepeatField = ({
  type,
  weekday,
  month,
  date,
  time,
  disabled,
}) => {
  return (
    <Stack gap={1}>
      <Typography variant="body2">반복 주기</Typography>
      <ToggleButtonGroup
        {...{
          ...type,
          color: 'secondary',
          exclusive: true,
          disabled,
        }}
        sx={{ width: '100%', '& button': { width: '100%' } }}
      >
        {type.list.map(({ label, value }) => (
          <ToggleButton value={value} key={`repeat_${value}`}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      <Stack direction="row" gap={1} sx={{ flexWrap: 'wrap' }}>
        {type.value === REPEAT_OPTION_WEEKLY && (
          <Stack gap={1} sx={{ width: '100%' }}>
            <Typography variant="body2">반복 요일 선택</Typography>
            <ToggleButtonGroup
              {...{
                color: 'secondary',
                value: weekday.value,
                onChange: weekday.onChange,
                disabled,
              }}
              sx={{ width: '100%', '& button': { width: '100%' } }}
            >
              {moment.weekdaysShort().map((l, i) => (
                <ToggleButton value={i} key={`weekday_${l}`}>
                  {l}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Stack>
        )}
        {type.value === REPEAT_OPTION_YEARLY && (
          <Stack gap={1} minWidth="25%">
            <Typography variant="body2">반복 월 선택</Typography>
            <Select
              {...{
                name: month.name || 'month',
                value: month.value,
                onChange: (e) =>
                  month.onChange(e, CAL_REGISTER_FIELD_YEARLY_DATEPICKER),
                disabled,
              }}
            >
              {moment
                .months()
                .map((label) => label)
                .map((v, i) => (
                  <MenuItem value={i} key={`months_${v}`}>
                    {v}
                  </MenuItem>
                ))}
            </Select>
          </Stack>
        )}
        {(type.value === REPEAT_OPTION_YEARLY ||
          type.value === REPEAT_OPTION_MONTHLY) && (
          <Stack gap={1} minWidth="25%" width="50%">
            <Typography variant="body2">반복 일자 선택</Typography>
            <Select
              {...{
                name: date.name,
                value: date.value,
                onChange: (e) =>
                  date.onChange(e, CAL_REGISTER_FIELD_MONTHLY_DATEPICKER),
                disabled,
              }}
            >
              {Array.from({ length: 31 }, (v, k) => k + 1).map((v) => (
                <MenuItem value={v} key={`dates_${v}`}>
                  {`${v}일`}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        )}
        {type.value !== '' && (
          <Stack gap={1} minWidth="30%" width="100%">
            <Typography variant="body2">반복 시간 선택</Typography>
            <TextField
              {...{
                ...time,
                type: 'time',
                disabled,
              }}
              sx={{ '& input': { px: '12.5px', py: '14px' } }}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default CalendarRepeatField;
